import { Directive, ElementRef, Input } from '@angular/core';

const presets = {
  itemsPerPage: {
    from: 1,
    to: 10000,
    default: 20,
  },
  percentage: {
    from: 0,
    to: 100,
  },
};

type PresetId = keyof typeof presets;

interface Options {
  from?: number;
  to?: number;
  default?: number;
  preset?: PresetId;
}

@Directive({
  selector: '[mdRangeInput]',
})
export class RangeInputDirective {
  options: Options = {
    from: 0,
    to: Infinity,
    default: 1,
  };

  @Input('mdRangeInput') set inputOptions(options: Options | PresetId) {
    if (typeof options !== 'object') {
      this.options = presets[options];
    } else if (options.preset && presets[options.preset]) {
      this.options = presets[options.preset];
    } else {
      this.options = {
        ...this.options,
        ...(options ? options : {}),
      };
    }
  }

  constructor(private elRef: ElementRef) {
    const el = elRef.nativeElement;

    el.addEventListener('input', (event: KeyboardEvent) => {
      if (el.value === '') {
        return;
      }
      const value = parseInt(el.value, 10);
      if (isNaN(value)) {
        el.value = this.options.default;
        // @ts-expect-error
      } else if (value < this.options.from) {
        el.value = this.options.from;
        // @ts-expect-error
      } else if (value > this.options.to) {
        el.value = this.options.to;
      } else {
        return;
      }
    });
    el.addEventListener('blur', (event: FocusEvent) => {
      if (el.value === '') {
        el.value = this.options.default;
      }
    });
  }
}
